import React from "react"

/** One setting of the inspector: a heading and its controls, named for screen readers. */
const Field: React.FC<{
  label: string
  /** Controls next to the heading, such as a "Use defaults" link. */
  extra?: React.ReactNode
  children: React.ReactNode
}> = ({ label, extra, children }) => (
  <section className="ts-field" aria-label={label}>
    <div className="ts-field__head">
      <h3 className="ts-field__label">{label}</h3>
      {extra}
    </div>
    {children}
  </section>
)

export default Field
